import { render, staticRenderFns } from "./courseChapterLive.vue?vue&type=template&id=56754a26&scoped=true&"
import script from "./courseChapterLive.vue?vue&type=script&lang=js&"
export * from "./courseChapterLive.vue?vue&type=script&lang=js&"
import style0 from "./courseChapterLive.vue?vue&type=style&index=0&id=56754a26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56754a26",
  null
  
)

export default component.exports